'use strict';

var SeasonalityAnalysisReviewRibbonDirective = function SeasonalityAnalysisReviewRibbonDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/seasonality-analysis-review-ribbon.html')
  };
};
SeasonalityAnalysisReviewRibbonDirective.$inject = [];
module.exports = SeasonalityAnalysisReviewRibbonDirective;